module.exports = __webpack_public_path__ + "static/media/login-error.564d1df9.svg";